const Menu = {
    assets: {
        menuItems: [
            { name: 'Images', link: 'images' },
            /*{name: 'Videos', link: 'videos'},*/
            { name: 'Customization', link: 'customization' },
            { name: 'Tracking hooks', link: 'tracking' },
            { name: 'Custom Fonts', link: 'customFonts' },
            { name: 'Other', link: 'other' }
        ]
    },
    pages: {
        name: 'Pages',
        link: 'pages',
        children: [
            { name: 'Product', link: 'product' },
            // {name: 'Rooms & Rates', link: 'rooms-rates'},
            { name: 'Add-Ons', link: 'addOn' },
            { name: 'Retail Products', link: 'retailProducts' },
            { name: 'Price Summary', link: 'priceSummary' },
            { name: 'Sign-In', link: 'signIn' },
            { name: 'Search', link: 'searchSettings' },
            { name: 'Global Bar', link: 'globalBar' },
            { name: 'Filters', link: 'filters' },
            { name: 'Checkout', link: 'cart' },
            { name: 'Guest & Payment', link: 'guestPayment' },
            // {name: 'Review', link: 'review'},
            { name: 'Confirmation', link: 'confirmation' },
            { name: 'Hotel', link: 'hotel' },
            { name: 'General', link: 'general', force: true },
            // {name: 'Find Res', link: 'find-res'},
            // {name: 'Search Results', link: 'modify-res'},
            // {name: 'Teaser', link: 'teaser'},
            // {name: 'Site-Wide (All PGS)', link: 'site-wide'},
        ],
        search: [],
        guestAndPaymentChildren: [
            { name: 'Guest Information', link: 'guest-payment/information' }
            // {name: 'Policies', link: 'policies'},
            // {name: 'Customization', link: 'customization'},
        ],
        productChildren: [
            { name: 'Filters', link: 'addOn' },
            { name: 'Product Cards', link: 'addOn' },
            { name: 'Product Details', link: 'addOn' },
            { name: 'Customization', link: 'customization' }
        ],
        product: [
            { name: 'Settings', link: 'product/settings' },
            { name: 'Product icons', link: 'product/icons' },
            { name: 'Labels', link: 'product/labels' }
        ],
        addOns: [{ name: 'Labels', link: 'addOn/labels' }],
        retailProducts: [{ name: 'Settings', link: 'retailProducts/settings' }],
        addOn: [{ name: 'Labels', link: 'addOn/labels' }],
        priceSummary: [{ name: 'Labels', link: 'priceSummary/labels' }],
        signIn: [{ name: 'Labels', link: 'signIn/labels' }],
        searchSettings: [
            { name: 'Settings', link: 'searchSettings/settings' },
            { name: 'Labels', link: 'searchSettings/labels' }
        ],
        globalBar: [
            { name: 'Settings', link: 'globalBar/settings' },
            { name: 'Labels', link: 'globalBar/labels' }
        ],
        filters: [
            { name: 'Settings', link: 'filters/settings' },
            { name: 'Labels', link: 'filters/labels' }
        ],
        cart: [{ name: 'Labels', link: 'cart/labels' }],
        confirmation: [
            { name: 'Settings', link: 'confirmation/settings' },
            { name: 'Labels', link: 'confirmation/labels' }
        ],
        general: [
            { name: 'Settings', link: 'general/settings' },
            { name: 'Tracking hooks', link: 'general/tracking-hooks' },
            { name: 'Policy Urls', link: 'general/policy-urls' },
            { name: 'Labels', link: 'general/labels' }
        ],
        hotel: [
            { name: 'Settings', link: 'hotel/settings' },
            { name: 'Menu Content', link: 'hotel/menu-content' },
            { name: 'Labels', link: 'hotel/labels' }
        ],
        guestPayment: [
            { name: 'Settings', link: 'guestPayment/settings' },
            { name: 'Labels', link: 'guestPayment/labels' }
        ],
        findRes: [
            { name: 'With Account', link: 'product' },
            { name: 'With Confirmation', link: 'product' },
            { name: 'Customization', link: 'customization' }
        ],
        searchRes: [
            { name: 'Cards', link: 'product' },
            { name: 'Details', link: 'product' },
            { name: 'Customization', link: 'customization' }
        ],
        customization: [
            { name: 'Top', link: 'product' },
            { name: 'Middle', link: 'product' },
            { name: 'Bottom', link: 'product' },
            { name: 'Tracking', link: 'product' }
        ],
        guestInformation: [{ name: 'Settings', link: 'guest-payment/information/settings' }],
        'tracking-hooks': []
    },
    theme: {
        name: 'Theme',
        link: 'theme',
        global: [
            { name: 'Colors', link: 'colors' },
            //{name: 'Images', link: 'images'},
            { name: 'Buttons and Links', link: 'buttons' },
            { name: 'Global', link: 'global' }
        ],

        components: [
            { name: 'Header', link: 'header' },
            // {name: 'Card', link: 'card'},
            { name: 'Calendar', link: 'calendar' },
            { name: 'Gallery', link: 'gallery' },
            // {name: 'Filter Bar', link: 'filter-bar'},
            { name: 'Form', link: 'form' },
            { name: 'Custom Content', link: 'customContent' }
        ]
    },
    inContextTheme:
        [
            {
                name: 'Colors',
                key: 'colors',
                groups: [
                    {
                        title: 'Primary colors',
                        key: 'primary',
                        rows: [
                            { label: 'Primary background', key: 'primary', defaultValue: '#309AB5' },
                            { label: 'Primary text', key: 'primary-foreground', defaultValue: '#FFFFFF' },
                            { label: 'Primary button background', key: 'primary-button', defaultValue: '#404247' },
                            { label: 'Primary button text', key: 'primary-button-foreground', defaultValue: '#FFFFFF' }
                        ]
                    },
                    {
                        title: 'Secondary colors',
                        key: 'secondary',
                        rows: [
                            { label: 'Secondary background', key: 'secondary', defaultValue: '#FFFFFF' },
                            { label: 'Secondary text', key: 'secondary-foreground', defaultValue: '#121315' }
                        ]
                    },
                    {
                        title: 'Accent colors',
                        key: 'accent',
                        rows: [
                            { label: 'Accent background', key: 'accent', defaultValue: '#BCEAF8' },
                            { label: 'Accent text', key: 'accent-foreground', defaultValue: '#404247' }
                        ]
                    },
                    {
                        title: 'Base colors',
                        key: 'base',
                        rows: [
                            { label: 'Base background', key: 'background', defaultValue: '#F6F6F7' },
                            { label: 'Base text', key: 'foreground', defaultValue: '#333333' }
                        ]
                    },
                    {
                        title: 'Navbar colors',
                        key: 'navbar',
                        rows: [
                            { label: 'Navbar background', key: 'navbar-background', defaultValue: '#FFFFFF' },
                            { label: 'Navbar text', key: 'navbar-foreground', defaultValue: '#333333' }
                        ]
                    },
                    {
                        title: 'Card colors',
                        key: 'card',
                        rows: [
                            { label: 'Card background', key: 'card', defaultValue: '#FFFFFF' },
                            { label: 'Card text', key: 'card-foreground', defaultValue: '#404247' }
                        ]
                    },
                    {
                        title: 'Popover colors',
                        key: 'popover',
                        rows: [
                            { label: 'Popover background', key: 'popover', defaultValue: '#FFFFFF' },
                            { label: 'Popover text', key: 'popover-foreground', defaultValue: '#404247' }
                        ]
                    },
                    {
                        title: 'Muted colors',
                        key: 'muted',
                        rows: [
                            { label: 'Muted background', key: 'muted', defaultValue: '#F6F6F7' },
                            { label: 'Muted text', key: 'muted-foreground', defaultValue: '#404247' }
                        ]
                    },
                    {
                        title: 'Info colors',
                        key: 'info',
                        rows: [
                            { label: 'Info background', key: 'info', defaultValue: '#0891B2' },
                            { label: 'Info text', key: 'info-foreground', defaultValue: '#ECFEFF' }
                        ]
                    },
                    {
                        title: 'Success colors',
                        key: 'success',
                        rows: [
                            { label: 'Success background', key: 'success', defaultValue: '#15803D' },
                            { label: 'Success text', key: 'success-foreground', defaultValue: '#DCFCE7' }
                        ]
                    },
                    {
                        title: 'Warning colors',
                        key: 'warning',
                        rows: [
                            { label: 'Warning background', key: 'warning', defaultValue: '#A16207' },
                            { label: 'Warning text', key: 'warning-foreground', defaultValue: '#FEF9C3' }
                        ]
                    },
                    {
                        title: 'Error colors',
                        key: 'error',
                        rows: [
                            { label: 'Error background', key: 'destructive', defaultValue: '#DC2626' },
                            { label: 'Error text', key: 'destructive-foreground', defaultValue: '#FEF2F2' }
                        ]
                    },
                    {
                        title: 'Border and Input colors',
                        key: 'borderInput',
                        rows: [
                            { label: 'Border', key: 'border', defaultValue: '#E5E5E5' },
                            { label: 'Input', key: 'input', defaultValue: '#E5E5E5' },
                            { label: 'Focus', key: 'ring', defaultValue: '#007B94' }
                        ]
                    }
                ]
            },
            {
                name: 'Typography',
                key: 'typography',
                groups: [
                    {
                        title: 'Titles and headings',
                        key: 'typo-headings',
                        rows: [
                            {
                                label: 'Titles and headings',
                                key: 'font-titles',
                                type: 'font',
                                defaultValue: 'IBM Plex sans, ui-sans-serif, sans-serif, system-ui'
                            }
                        ]
                    },
                    {
                        title: 'Body text',
                        key: 'typo-body',
                        rows: [
                            {
                                label: 'Body font',
                                key: 'font-body',
                                type: 'font',
                                defaultValue: 'IBM Plex sans, ui-sans-serif, sans-serif, system-ui'
                            }
                        ]
                    }
                ]
            },
            { name: 'Radius', key: 'radius', defaultValue: '1' },
            { name: 'Spacing', key: 'spacing', defaultValue: '0.25' },
            {
                name: 'Shadow',
                key: 'shadow',
                groups: [
                    {
                        key: 'shadow-color',
                        name: 'Color',
                        type: 'color',
                        defaultValue: 'hsl(0 0% 0%)'
                    },
                    {
                        key: 'shadow-opacity',
                        name: 'Opacity',
                        min: 0,
                        max: 1,
                        step: 0.01,
                        unit: '',
                        defaultValue: '0.5'
                    },
                    {
                        key: 'shadow-blur-radius',
                        name: 'Blur Radius',
                        min: 0,
                        max: 50,
                        step: 1,
                        unit: 'px',
                        defaultValue: '10'
                    },
                    {
                        key: 'shadow-spread',
                        name: 'Spread',
                        min: -50,
                        max: 50,
                        step: 1,
                        unit: 'px',
                        defaultValue: '0'
                    },
                    {
                        key: 'shadow-offset-x',
                        name: 'Offset X',
                        min: -50,
                        max: 50,
                        step: 1,
                        unit: 'px',
                        defaultValue: '0'
                    },
                    {
                        key: 'shadow-offset-y',
                        name: 'Offset Y',
                        min: -50,
                        max: 50,
                        step: 1,
                        unit: 'px',
                        defaultValue: '0'
                    }
                ]
            }
        ]

}

export default Menu;



// WEBPACK FOOTER //
// ./src/config/Menu.js